import { Clock, Shield, TrendingUp } from 'lucide-react';

export function ROIBanner() {
  return (
    <div className="glass-card p-5 border border-primary/20 bg-primary/5 space-y-4">
      <p className="text-xs font-semibold text-primary uppercase tracking-wide text-center">
        Consentink vaut bien plus que son prix
      </p>
      <div className="grid grid-cols-3 gap-4">
        <div className="text-center space-y-1">
          <div className="flex justify-center"><Clock size={18} className="text-primary" /></div>
          <p className="text-sm font-bold">10h / mois</p>
          <p className="text-[10px] text-muted-foreground leading-tight">récupérées vs formulaires papier</p>
        </div>
        <div className="text-center space-y-1">
          <div className="flex justify-center"><Shield size={18} className="text-primary" /></div>
          <p className="text-sm font-bold">Zéro litige</p>
          <p className="text-[10px] text-muted-foreground leading-tight">PDF signé = preuve légale solide</p>
        </div>
        <div className="text-center space-y-1">
          <div className="flex justify-center"><TrendingUp size={18} className="text-primary" /></div>
          <p className="text-sm font-bold">+600€</p>
          <p className="text-[10px] text-muted-foreground leading-tight">de valeur récupérée / mois à 60€/h</p>
        </div>
      </div>
    </div>
  );
}
